import Slider from "react-slick";
import DrawLine from "./drawLine";
import PropTypes from "prop-types";
import Modal from "../../utils/customModal";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { formatNumber, errorContainer } from "../../utils/functions";
import { useDispatch, useSelector } from "react-redux";
import { getCreditLine } from "../../../Redux/reducer/credit-line";
import { getSessionInfo } from "../../../Redux/reducer/session";
import { getCustomerCreditLine } from "../../../Redux/actions/credit-line";

import Card from "canvas-core-react/lib/Card";
import Avatar from "canvas-core-react/lib/Avatar";
import IconChevronLeft from "canvas-core-react/lib/IconChevronLeft";
import IconChevronDown from "canvas-core-react/lib/IconChevronDown";
import IconChevronRight from "canvas-core-react/lib/IconChevronRight";

const CreditLine = (props) => {
  const dispatch = useDispatch();

  const { dashboard } = props;
  const { t } = useTranslation();
  const creditClass = dashboard ? "full-view" : "compact-view";
  const creditLines = useSelector((state) => getCreditLine(state));
  const [flex, setFlex] = useState(true);
  const [companiesDrop, setCompaniesDrop] = useState([]);
  const { allCompanies } = useSelector((state) => getSessionInfo(state));
  const [contentReady, setContentReady] = useState(false);
  const [errCreditLine, setErrCreditLine] = useState(null);
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  useEffect(() => {
    var _isMounted = true;

    if (allCompanies) {
      setFlex(false);
    }

    async function fetchCreditLine() {
      return await dispatch(getCustomerCreditLine(allCompanies));
    }

    fetchCreditLine()
      .then((response) => {
        if (_isMounted) {
          if (response.data.length <= 0) {
            var buttons = {
              continueBtn: {
                action: () =>
                  setModal({ show: false, content: null, onClose: undefined }),
                text: `${t("general.buttons.accept")}`,
              },
            };
            setModal({
              show: true,
              content: errorContainer(
                `${t("dashboard.creditLine.notAvailableTitle")}`,
                `${t("dashboard.creditLine.notAvailable")}`,
                buttons
              ),
              onClose: () =>
                setModal({ show: false, content: null, onClose: undefined }),
            });
          }

          setContentReady(true);
        }
      })
      .catch((err) => {
        if (_isMounted) {
          var notification = err.response.data.notifications[0];
          var buttons = {
            continueBtn: {
              action: () =>
                setModal({ show: false, content: null, onClose: undefined }),
              text: `${t("general.buttons.close")}`,
            },
          };

          setModal({
            show: true,
            content: errorContainer(
              notification.message,
              notification.description,
              buttons
            ),
            onClose: () =>
              setModal({ show: false, content: null, onClose: undefined }),
          });

          setErrCreditLine(notification.description);
        }
      });

    return () => {
      _isMounted = false;
    };
  }, []);

  const getLines = () => {
    return allCompanies === true ? getAllCreditLines() : getCurrentLines();
  };

  const getAllCreditLines = () => {
    const SliderProps = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };

    return (
      <Slider {...SliderProps}>
        {undefined !== creditLines[0].company &&
          creditLines.map((companieLine) => (
            <Card
              key={`company-${companieLine.id}`}
              className={`company-credit-line ${
                companiesDrop[`${companieLine.id}`] !== undefined &&
                companiesDrop[`${companieLine.id}`] === true
                  ? "expanded"
                  : "collapsed"
              }`}
              type={`floatLow`}
              lgPadding={18}
              mdPadding={18}
              smPadding={18}
            >
              <div className="name">
                <div>
                  <Avatar
                    id={`company-${companieLine.id}`}
                    text={`${companieLine?.name?.substring(0, 3)}`}
                    ariaLabel={companieLine?.name}
                    size={32}
                    className="avatar"
                  />
                  {companieLine.name}
                </div>
                <div
                  onClick={() => openDrop(companieLine.id)}
                  className="open-info"
                >
                  <IconChevronDown />
                </div>
              </div>
              {LineIfo(companieLine.company.facilityResponse, companieLine.id)}
            </Card>
          ))}
      </Slider>
    );
  };

  const openDrop = (id) => {
    const tmpMenu = [...companiesDrop];
    tmpMenu[id] = tmpMenu[id] !== undefined ? !tmpMenu[id] : true;
    setCompaniesDrop(tmpMenu);
  };

  const getCurrentLines = () => {
    return creditLines
      .filter((creditLine) => creditLine.isReverseLine)
      .map((creditLine, idx) => printLine(idx, creditLine));
  };

  const printLine = (idx, creditLine) => {
    return (
      <div key={idx} className={`mainCredit ${creditClass}`}>
        <DrawLine
          {...props}
          {...creditLine}
          holdMount={
            props.CurrencyMounts !== undefined
              ? props.CurrencyMounts[creditLine.currencyCode] || 0
              : 0
          }
          currencyCode={
            creditLine.currencyDetail !== undefined &&
            creditLine.currencyDetail.currencySymbol
          }
        />
        {creditLine.approvedAmount !== null && (
          <div className="mounts">
            <div className="available-amount">
              <p>{t("dashboard.creditLine.availableAmount")}</p>
              <h3>
                {creditLine.availableRFAmount !== null &&
                creditLine.availableRFAmount !== undefined
                  ? formatNumber(
                      creditLine.availableRFAmount,
                      creditLine.currencyDetail.currencySymbol
                    )
                  : "-"}
              </h3>
            </div>
            <div className="hold-amount">
              <p>{t("dashboard.creditLine.holdAmount")}</p>
              <h3>
                {creditLine.holdAmount !== null &&
                creditLine.holdAmount !== undefined
                  ? formatNumber(
                      creditLine.holdAmount,
                      creditLine.currencyDetail.currencySymbol
                    )
                  : "-"}
              </h3>
            </div>
            <div className="aprovedAmount">
              {dashboard ? (
                <React.Fragment>
                  <p>{t("dashboard.creditLine.totalAmount")}</p>
                  <h3>
                    {creditLine.approvedAmount !== null &&
                    creditLine.approvedAmount !== undefined
                      ? formatNumber(
                          creditLine.approvedAmount,
                          creditLine.currencyDetail.currencySymbol
                        )
                      : "-"}
                  </h3>
                </React.Fragment>
              ) : (
                <p>
                  {t("dashboard.creditLine.totalAmountComp")}:{" "}
                  <b>
                    {creditLine.approvedAmount !== null &&
                    creditLine.approvedAmount !== undefined
                      ? formatNumber(
                          creditLine.approvedAmount,
                          creditLine.currencyDetail.currencySymbol
                        )
                      : "-"}
                  </b>
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const LineIfo = (facilities, companyId) => {
    const { CurrencyMounts } = props;
    let data = {
      bills: [],
      retained: [],
      available: [],
    };

    facilities.map(
      ({
        holdAmount,
        availableRFAmount,
        currencyDetail: { currencySymbol, currencyCode },
      }) => {
        data.bills.push(
          `${currencySymbol} ${
            CurrencyMounts[companyId] !== undefined
              ? CurrencyMounts[companyId][currencyCode] || 0
              : "0"
          }`
        );
        data.retained.push(formatNumber(holdAmount, currencySymbol));
        data.available.push(formatNumber(availableRFAmount, currencySymbol));
      }
    );

    return facilities.length > 0 ? (
      <div className={`info`}>
        <div className="bills">
          <p>Facturas seleccionadas: </p>
          {data.bills.map((mount, idx) => (
            <p key={`bills-${idx}`}>{mount}</p>
          ))}
        </div>
        <div className="retained">
          <p>Retenido Reverse Factoring: </p>
          {data.retained.map((mount, idx) => (
            <p key={`reatined-${idx}`}>{mount}</p>
          ))}
        </div>
        <div className="available">
          <p>Disponible Reverse Factoring: </p>
          {data.available.map((mount, idx) => (
            <p key={`available-${idx}`}>{mount}</p>
          ))}
        </div>
      </div>
    ) : null;
  };

  return (
    <div className={`${flex ? "flex-element" : ""} credit-wrapper`}>
      {contentReady ? (
        getLines()
      ) : errCreditLine === null ? (
        <div className="linear-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      ) : (
        <p className="error-credit-line">{errCreditLine}</p>
      )}
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </div>
  );
};

CreditLine.propTypes = {
  holdMount: PropTypes.number,
  dashboard: PropTypes.bool,
};

CreditLine.defaultProps = {
  dashboard: true,
};

export default CreditLine;

const NextArrow = ({ className, style, onClick }) => {
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <IconChevronRight />
    </div>
  );
};

const PrevArrow = ({ className, style, onClick }) => {
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <IconChevronLeft />
    </div>
  );
};
